import Layout from "components/layout/Layout";
import {Link} from "react-router-dom";
const DataRemovalPolicy = () => {
    return (
        <Layout
            headerStyle={1}
            footerStyle={1}
            breadcrumbTitle={ <> Data <span>Removal Policy</span> </> } >
            <section className="job-details-area pb-150">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10">
                            <div className="job-details-content">
                                <div className="job-qualifications">
                                    <p>
                                        Your data, your control. BodyLytiX enables you to request full data removal at any time. We process these requests promptly, ensuring your information is deleted while adhering to legal requirements. For details, contact &nbsp;
                                        <a href="mailto:support@bodylytix.ai">
                                            support@bodylytix.ai
                                        </a>.
                                    </p>
                                </div>
                                <div className="job-qualifications">
                                    <strong>1. Your Right to Data Removal</strong>
                                    <p>
                                        You have the right to request the deletion of your personal data at any time. This includes any information collected during your use of the BodyLytiX platform, including account details, activity data, and connected third-party data.
                                    </p>
                                </div>
                                <div className="job-qualifications">
                                    <strong>2. How to Request Data Removal</strong>
                                    <p>
                                        To request the deletion of your data, you can:
                                    </p>
                                    <ul style={{ marginTop: "10px" }}>
                                        <li>
                                            <strong>
                                                In-App Request: 
                                            </strong>
                                            <span> Navigate to your account settings, select the "Delete Account" option, and follow the prompts.</span>
                                        </li>
                                        <li>
                                            <strong>
                                                Email Request: 
                                            </strong>
                                            <span> Send a deletion request to <a href="mailto:support@bodylytix.ai">
                                                support@bodylytix.ai
                                            </a> with your account details (e.g., registered email address).</span>
                                        </li>
                                    </ul>
                                    <p>
                                        We may require verification to confirm your identity before processing your request to ensure the security of your account.
                                    </p>
                                </div>
                                <div className="job-qualifications">
                                    <strong>3. Processing Timeline</strong>
                                    <p>
                                        Upon receiving your data removal request:
                                    </p>
                                    <ul style={{ marginTop: "10px" }}>
                                        <li>
                                            <strong>
                                                Acknowledgment: 
                                            </strong>
                                            <span> We will confirm receipt of your request within 5 business days.</span>
                                        </li>
                                        <li>
                                            <strong>
                                                Deletion Completion: 
                                            </strong>
                                            <span> Your data will be permanently deleted from our systems within 30 days, unless applicable laws require us to retain certain data for a longer period.</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="job-qualifications">
                                    <strong>4. Data Retention Exceptions</strong>
                                    <p>
                                        In certain circumstances, we may retain limited data to comply with legal, regulatory, or contractual obligations, such as:
                                    </p>
                                    <ul style={{ marginTop: "10px" }}>
                                        <li>
                                            <strong>
                                                Legal Compliance: 
                                            </strong>
                                            <span> Retaining data required for legal obligations, tax filings, or resolving disputes.</span>
                                        </li>
                                        <li>
                                            <strong>
                                                Anonymized Data: 
                                            </strong>
                                            <span> Aggregated and anonymized data may be retained for research or analytics purposes, as it is no longer linked to your identity.</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="job-qualifications">
                                    <strong>5. Impact of Data Removal</strong>
                                    <p>
                                        When your data is removed:
                                    </p>
                                    <ul style={{ marginTop: "10px" }}>
                                        <li>
                                            <strong>
                                                Account Termination: 
                                            </strong>
                                            <span> Your BodyLytiX account will be permanently deleted and cannot be recovered.</span>
                                        </li>
                                        <li>
                                            <strong>
                                                Data Deletion: 
                                            </strong>
                                            <span> All associated fitness data, AI Coach settings, and progress tracking will be erased.</span>
                                        </li>
                                        <li>
                                            <strong>
                                                Third-Party Connections:
                                            </strong>
                                            <span> We will disconnect any linked third-party integrations (e.g., Garmin, Apple Health) and ensure that data shared with BodyLytiX is deleted.</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="job-qualifications">
                                    <strong>6. Contact Us</strong>
                                    <p>
                                        If you have questions or concerns about this Privacy Policy or how we handle your data, contact us at:
                                    </p>
                                    <div>
                                        <strong>
                                            Email: &nbsp;
                                        </strong>
                                        <a href="mailto:support@bodylytix.ai">
                                            support@bodylytix.ai
                                        </a>
                                    </div>
                                    <div>
                                        <strong>
                                            Website: &nbsp;
                                        </strong>
                                        <a href="https://www.bodylytix.ai/">
                                            www.bodylytix.ai
                                        </a>
                                    </div>
                                    <div>
                                        <strong>Contact Form: </strong>
                                        <span>
                                          <Link to="/contact">
                                            contact us
                                          </Link>
                                        </span>
                                    </div>
                                </div>
                                <hr>
                                </hr>
                                <div className="job-qualifications">
                                    <p className="info-one">
                                    At BodyLytiX, your data belongs to you. We are committed to ensuring that your information is handled with the utmost care and respect, including giving you the ability to delete it whenever you choose.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    );
};
export default DataRemovalPolicy;